"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INSUFFICIENT_FUNDS = exports.TRANSACTION_LOCKED = exports.VM_EXCEPTIONS = exports.VM_EXCEPTION = exports.GAS_LIMIT = exports.INTRINSIC_GAS_TOO_LOW = exports.REPLACED = exports.UNDERPRICED = exports.NONCE_TOO_LOW = exports.INVALID_SENDER = void 0;
/**
 * Returned if the transaction contains an invalid signature.
 */
exports.INVALID_SENDER = "invalid sender";
/**
 * Returned if the nonce of a transaction is lower than the one present in the local chain.
 */
exports.NONCE_TOO_LOW = "nonce too low";
/**
 * Returned if a transaction's gas price is below the minimum configured for the transaction pool.
 */
exports.UNDERPRICED = "transaction underpriced";
/**
 * Returned if a transaction's gas price is below the minimum configured for the transaction pool.
 */
exports.REPLACED = "transaction replaced by better transaction";
/**
 * Returned if the transaction is specified to use less gas than required to start the invocation.
 */
exports.INTRINSIC_GAS_TOO_LOW = "intrinsic gas too low";
/**
 * Returned if a transaction's requested gas limit exceeds the maximum allowance of the current block.
 */
exports.GAS_LIMIT = "exceeds block gas limit";
/**
 * Prefix for a single VM Exception occurring when running a transaction or block
 */
exports.VM_EXCEPTION = "VM Exception while processing transaction: ";
/**
 * Prefix for multiple VM Exceptions occurring when running transactions or a block
 */
exports.VM_EXCEPTIONS = "Multiple VM Exceptions while processing transactions: : \n\n";
/**
 * Returned if a replacement transaction is sent while the potentially replaced transaction is being mined.
 */
exports.TRANSACTION_LOCKED = "transaction can't be replaced, mining has already started. (please open an issue with reproduction steps: https://github.com/trufflesuite/ganache/issues/new)";
/**
 * Returned if a transaction may require more funds than than account currently has available.
 */
exports.INSUFFICIENT_FUNDS = "insufficient funds for gas * price + value";
//# sourceMappingURL=errors.js.map